export const GUEST_MESSAGE_COUNT = 5

export const wellMapping = {
    API: 'API Number',
    SYMNUM: 'Well Type',
    COMPLETION: 'Completion Date',
    FIELD_NAME: 'Field Name',
    LEASE_NAME: 'Lease Name',
    LEASE_ID: 'Lease Number',
    OPERATOR: 'Operator Name',
    OPERATOR_CONTACT: 'Operator Phone Number',
    PLUG_DATE: 'Plug Date',
    TOTAL_DEPTH: 'Total Depth',
    TOTAL_DEPT: 'Total Depth',
    LAST_PROD: 'Date of Last Production',
    LSE_GAS_PROD_VOL: 'Gas Produced',
    LSE_OIL_PROD_VOL: 'Oil Produced',
    LSE_COND_PROD_VOL: 'Condensate Produced',
    LSE_CSGD_PROD_VOL: 'Casinghead Gas Produced',
    LAST_FLARED: 'Date of Last Flare/Vent',
    FLARE_VOL: 'Volume Flared or Vented',
    COUNTY: 'County',
    LATERAL_LENGTH: 'Lateral Length',
    W_P: 'Well or Pipeline',
};

export const pipelineMapping = {
    "PIPE_LENGTH": "Length",
    "COMMODITY1": "Commodity",
    "COUNTY": "County",
    "DIAMETER": "Diameter",
    "INTERSTATE": "Interstate",
    "OPERATOR_CONTACT": "Operator Contact",
    "OPER_NM": "Operator Name",
    "OPS_ID": "OPS ID",
    "P5_NUM": "P5 Number",
    "STATUS_CD": "Status Code",
    "SUBSYS_NM": "Subsystem Name",
    "SYSTYPE": "System Type",
    "SYS_ID": "System ID",
    "SYS_NM": "System Name",
    "T4PERMIT": "T4 Permit",
    W_P: 'Well or Pipeline',
};

export const countyToCountyCode = {
    "Anderson": "001",
    "Andrews": "003",
    "Angelina": "005",
    "Aransas": "007",
    "Archer": "009",
    "Armstrong": "011",
    "Atascosa": "013",
    "Austin": "015",
    "Bailey": "017",
    "Bandera": "019",
    "Bastrop": "021",
    "Baylor": "023",
    "Bee": "025",
    "Bell": "027",
    "Bexar": "029",
    "Blanco": "031",
    "Borden": "033",
    "Bosque": "035",
    "Bowie": "037",
    "Brazoria": "039",
    "Brazos": "041",
    "Brewster": "043",
    "Briscoe": "045",
    "Brooks": "047",
    "Brown": "049",
    "Burleson": "051",
    "Burnet": "053",
    "Caldwell": "055",
    "Calhoun": "057",
    "Callahan": "059",
    "Cameron": "061",
    "Camp": "063",
    "Carson": "065",
    "Cass": "067",
    "Castro": "069",
    "Chambers": "071",
    "Cherokee": "073",
    "Childress": "075",
    "Clay": "077",
    "Cochran": "079",
    "Coke": "081",
    "Coleman": "083",
    "Collin": "085",
    "Collingsworth": "087",
    "Colorado": "089",
    "Comal": "091",
    "Comanche": "093",
    "Concho": "095",
    "Cooke": "097",
    "Coryell": "099",
    "Cottle": "101",
    "Crane": "103",
    "Crockett": "105",
    "Crosby": "107",
    "Culberson": "109",
    "Dallam": "111",
    "Dallas": "113",
    "Dawson": "115",
    "Deaf Smith": "117",
    "Delta": "119",
    "Denton": "121",
    "DeWitt": "123",
    "Dickens": "125",
    "Dimmit": "127",
    "Donley": "129",
    "Duval": "131",
    "Eastland": "133",
    "Ector": "135",
    "Edwards": "137",
    "El Paso": "141",
    "Ellis": "139",
    "Erath": "143",
    "Falls": "145",
    "Fannin": "147",
    "Fayette": "149",
    "Fisher": "151",
    "Floyd": "153",
    "Foard": "155",
    "Fort Bend": "157",
    "Franklin": "159",
    "Freestone": "161",
    "Frio": "163",
    "Gaines": "165",
    "Galveston": "167",
    "Garza": "169",
    "Gillespie": "171",
    "Glasscock": "173",
    "Goliad": "175",
    "Gonzales": "177",
    "Gray": "179",
    "Grayson": "181",
    "Gregg": "183",
    "Grimes": "185",
    "Guadalupe": "187",
    "Hale": "189",
    "Hall": "191",
    "Hamilton": "193",
    "Hansford": "195",
    "Hardeman": "197",
    "Hardin": "199",
    "Harris": "201",
    "Harrison": "203",
    "Hartley": "205",
    "Haskell": "207",
    "Hays": "209",
    "Hemphill": "211",
    "Henderson": "213",
    "Hidalgo": "215",
    "Hill": "217",
    "Hockley": "219",
    "Hood": "221",
    "Hopkins": "223",
    "Houston": "225",
    "Howard": "227",
    "Hudspeth": "229",
    "Hunt": "231",
    "Hutchinson": "233",
    "Irion": "235",
    "Jack": "237",
    "Jackson": "239",
    "Jasper": "241",
    "Jeff Davis": "243",
    "Jefferson": "245",
    "Jim Hogg": "247",
    "Jim Wells": "249",
    "Johnson": "251",
    "Jones": "253",
    "Karnes": "255",
    "Kaufman": "257",
    "Kendall": "259",
    "Kenedy": "261",
    "Kent": "263",
    "Kerr": "265",
    "Kimble": "267",
    "King": "269",
    "Kinney": "271",
    "Kleberg": "273",
    "Knox": "275",
    "La Salle": "283",
    "Lamar": "277",
    "Lamb": "279",
    "Lampasas": "281",
    "Lavaca": "285",
    "Lee": "287",
    "Leon": "289",
    "Liberty": "291",
    "Limestone": "293",
    "Lipscomb": "295",
    "Live Oak": "297",
    "Llano": "299",
    "Loving": "301",
    "Lubbock": "303",
    "Lynn": "305",
    "Madison": "313",
    "Marion": "315",
    "Martin": "317",
    "Mason": "319",
    "Matagorda": "321",
    "Maverick": "323",
    "McCulloch": "307",
    "McLennan": "309",
    "McMullen": "311",
    "Medina": "325",
    "Menard": "327",
    "Midland": "329",
    "Milam": "331",
    "Mills": "333",
    "Mitchell": "335",
    "Montague": "337",
    "Montgomery": "339",
    "Moore": "341",
    "Morris": "343",
    "Motley": "345",
    "Nacogdoches": "347",
    "Navarro": "349",
    "Newton": "351",
    "Nolan": "353",
    "Nueces": "355",
    "Ochiltree": "357",
    "Oldham": "359",
    "Orange": "361",
    "Palo Pinto": "363",
    "Panola": "365",
    "Parker": "367",
    "Parmer": "369",
    "Pecos": "371",
    "Polk": "373",
    "Potter": "375",
    "Presidio": "377",
    "Rains": "379",
    "Randall": "381",
    "Reagan": "383",
    "Real": "385",
    "Red River": "387",
    "Reeves": "389",
    "Refugio": "391",
    "Roberts": "393",
    "Robertson": "395",
    "Rockwall": "397",
    "Runnels": "399",
    "Rusk": "401",
    "Sabine": "403",
    "San Augustine": "405",
    "San Jacinto": "407",
    "San Patricio": "409",
    "San Saba": "411",
    "Schleicher": "413",
    "Scurry": "415",
    "Shackelford": "417",
    "Shelby": "419",
    "Sherman": "421",
    "Smith": "423",
    "Somervell": "425",
    "Starr": "427",
    "Stephens": "429",
    "Sterling": "431",
    "Stonewall": "433",
    "Sutton": "435",
    "Swisher": "437",
    "Tarrant": "439",
    "Taylor": "441",
    "Terrell": "443",
    "Terry": "445",
    "Throckmorton": "447",
    "Titus": "449",
    "Tom Green": "451",
    "Travis": "453",
    "Trinity": "455",
    "Tyler": "457",
    "Upshur": "459",
    "Upton": "461",
    "Uvalde": "463",
    "Val Verde": "465",
    "Van Zandt": "467",
    "Victoria": "469",
    "Walker": "471",
    "Waller": "473",
    "Ward": "475",
    "Washington": "477",
    "Webb": "479",
    "Wharton": "481",
    "Wheeler": "483",
    "Wichita": "485",
    "Wilbarger": "487",
    "Willacy": "489",
    "Williamson": "491",
    "Wilson": "493",
    "Winkler": "495",
    "Wise": "497",
    "Wood": "499",
    "Yoakum": "501",
    "Young": "503",
    "Zapata": "505",
    "Zavala": "507"
}

export const codeCodeToCounty = {
    "001": "ANDERSON",
    "003": "ANDREWS",
    "005": "ANGELINA",
    "007": "ARANSAS",
    "009": "ARCHER",
    "011": "ARMSTRONG",
    "013": "ATASCOSA",
    "015": "AUSTIN",
    "017": "BAILEY",
    "019": "BANDERA",
    "021": "BASTROP", "023": "BAYLOR", "025": "BEE", "027": "BELL", "029": "BEXAR", "031": "BLANCO", "033": "BORDEN", "035": "BOSQUE", "037": "BOWIE", "039": "BRAZORIA", "041": "BRAZOS", "043": "BREWSTER", "045": "BRISCOE", "047": "BROOKS", "049": "BROWN", "051": "BURLESON", "053": "BURNET", "055": "CALDWELL", "057": "CALHOUN", "059": "CALLAHAN", "061": "CAMERON", "063": "CAMP", "065": "CARSON", "067": "CASS", "069": "CASTRO", "071": "CHAMBERS", "073": "CHEROKEE", "075": "CHILDRESS", "077": "CLAY", "079": "COCHRAN", "081": "COKE", "083": "COLEMAN", "085": "COLLIN", "087": "COLLINGSWORTH", "089": "COLORADO", "091": "COMAL", "093": "COMANCHE", "095": "CONCHO", "097": "COOKE", "099": "CORYELL", "101": "COTTLE", "103": "CRANE", "105": "CROCKETT", "107": "CROSBY", "109": "CULBERSON", "111": "DALLAM", "113": "DALLAS", "115": "DAWSON", "117": "DEAF SMITH", "119": "DELTA", "121": "DENTON", "123": "DEWITT", "125": "DICKENS", "127": "DIMMIT", "129": "DONLEY", "131": "DUVAL", "133": "EASTLAND", "135": "ECTOR", "137": "EDWARDS", "141": "EL PASO", "139": "ELLIS", "143": "ERATH", "145": "FALLS", "147": "FANNIN", "149": "FAYETTE", "151": "FISHER", "153": "FLOYD", "155": "FOARD", "157": "FORT BEND", "159": "FRANKLIN", "161": "FREESTONE", "163": "FRIO", "165": "GAINES", "167": "GALVESTON", "169": "GARZA", "171": "GILLESPIE", "173": "GLASSCOCK", "175": "GOLIAD", "177": "GONZALES", "179": "GRAY", "181": "GRAYSON", "183": "GREGG", "185": "GRIMES", "187": "GUADALUPE", "189": "HALE", "191": "HALL", "193": "HAMILTON", "195": "HANSFORD", "197": "HARDEMAN", "199": "HARDIN", "201": "HARRIS", "203": "HARRISON", "205": "HARTLEY", "207": "HASKELL", "209": "HAYS", "211": "HEMPHILL", "213": "HENDERSON", "215": "HIDALGO", "217": "HILL", "219": "HOCKLEY", "221": "HOOD", "223": "HOPKINS", "225": "HOUSTON", "227": "HOWARD", "229": "HUDSPETH", "231": "HUNT", "233": "HUTCHINSON", "235": "IRION", "237": "JACK", "239": "JACKSON", "241": "JASPER", "243": "JEFF DAVIS", "245": "JEFFERSON", "247": "JIM HOGG", "249": "JIM WELLS", "251": "JOHNSON", "253": "JONES", "255": "KARNES", "257": "KAUFMAN", "259": "KENDALL", "261": "KENEDY", "263": "KENT", "265": "KERR", "267": "KIMBLE", "269": "KING", "271": "KINNEY", "273": "KLEBERG", "275": "KNOX", "283": "LA SALLE", "277": "LAMAR", "279": "LAMB", "281": "LAMPASAS", "285": "LAVACA", "287": "LEE", "289": "LEON", "291": "LIBERTY", "293": "LIMESTONE", "295": "LIPSCOMB", "297": "LIVE OAK", "299": "LLANO", "301": "LOVING", "303": "LUBBOCK", "305": "LYNN", "313": "MADISON", "315": "MARION", "317": "MARTIN", "319": "MASON", "321": "MATAGORDA", "323": "MAVERICK", "307": "MCCULLOCH", "309": "MCLENNAN", "311": "MCMULLEN", "325": "MEDINA", "327": "MENARD", "329": "MIDLAND", "331": "MILAM", "333": "MILLS", "335": "MITCHELL", "337": "MONTAGUE", "339": "MONTGOMERY", "341": "MOORE", "343": "MORRIS", "345": "MOTLEY", "347": "NACOGDOCHES", "349": "NAVARRO", "351": "NEWTON", "353": "NOLAN", "355": "NUECES", "357": "OCHILTREE", "359": "OLDHAM", "361": "ORANGE", "363": "PALO PINTO", "365": "PANOLA", "367": "PARKER", "369": "PARMER", "371": "PECOS", "373": "POLK", "375": "POTTER", "377": "PRESIDIO", "379": "RAINS", "381": "RANDALL", "383": "REAGAN", "385": "REAL", "387": "RED RIVER", "389": "REEVES", "391": "REFUGIO", "393": "ROBERTS", "395": "ROBERTSON", "397": "ROCKWALL", "399": "RUNNELS", "401": "RUSK", "403": "SABINE", "405": "SAN AUGUSTINE", "407": "SAN JACINTO", "409": "SAN PATRICIO", "411": "SAN SABA", "413": "SCHLEICHER", "415": "SCURRY", "417": "SHACKELFORD", "419": "SHELBY", "421": "SHERMAN", "423": "SMITH", "425": "SOMERVELL", "427": "STARR", "429": "STEPHENS", "431": "STERLING", "433": "STONEWALL", "435": "SUTTON", "437": "SWISHER", "439": "TARRANT", "441": "TAYLOR", "443": "TERRELL", "445": "TERRY", "447": "THROCKMORTON", "449": "TITUS", "451": "TOM GREEN", "453": "TRAVIS", "455": "TRINITY", "457": "TYLER", "459": "UPSHUR", "461": "UPTON", "463": "UVALDE", "465": "VAL VERDE", "467": "VAN ZANDT", "469": "VICTORIA", "471": "WALKER", "473": "WALLER", "475": "WARD", "477": "WASHINGTON", "479": "WEBB", "481": "WHARTON", "483": "WHEELER", "485": "WICHITA", "487": "WILBARGER", "489": "WILLACY", "491": "WILLIAMSON", "493": "WILSON", "495": "WINKLER", "497": "WISE", "499": "WOOD", "501": "YOAKUM", "503": "YOUNG", "505": "ZAPATA", "507": "ZAVALA"
}

// export const CLASSIFICATIONS_TO_PNG_FILE_NAME = {
//     'Permitted Location': PermittedLocation,
//     'Dry Hole': DryHole,
//     'Oil Well': OilWell,
//     'Gas Well': GasWell,
//     'Oil/Gas Well': OilGasWell,
//     'Plugged Oil Well': PluggedOilWell,
//     'Plugged Gas Well': PluggedGasWell,
//     'Canceled Location': CanceledLocation,
//     'Plugged Oil/Gas Well': PluggedOilGasWell,
//     'Injection/Disposal Well': InjectionDisposalWell,
//     'Shut-In Well (Oil)': ShutInOil,
//     'Shut-In Well (Gas)': ShutInGas
// };

export const FIPStoDistrictCode = {
    '001': '06',
    '003': '08',
    '005': '06',
    '007': '04',
    '009': '09',
    '011': '10',
    '013': '01',
    '015': '03',
    '017': '8A',
    '019': '01',
    '021': '01',
    '023': '09',
    '025': '02',
    '027': '01',
    '029': '01',
    '031': '01',
    '033': '8A',
    '035': '05',
    '037': '06',
    '039': '03',
    '041': '03',
    '043': '08',
    '045': '10',
    '047': '04',
    '049': '7B',
    '051': '03',
    '053': '01',
    '055': '01',
    '057': '02',
    '059': '7B',
    '061': '04',
    '063': '06',
    '065': '10',
    '067': '06',
    '069': '10',
    '071': '03',
    '073': '06',
    '075': '10',
    '077': '09',
    '079': '8A',
    '081': '7C',
    '083': '7B',
    '085': '05',
    '087': '10',
    '089': '03',
    '091': '01',
    '093': '7B',
    '095': '7C',
    '097': '09',
    '099': '7B',
    '101': '8A',
    '103': '08',
    '105': '7C',
    '107': '8A',
    '109': '08',
    '111': '10',
    '113': '05',
    '115': '8A',
    '117': '10',
    '119': '05',
    '121': '09',
    '123': '02',
    '125': '8A',
    '127': '01',
    '129': '10',
    '131': '04',
    '133': '7B',
    '135': '08',
    '137': '01',
    '141': '08',
    '139': '05',
    '143': '7B',
    '145': '05',
    '147': '05',
    '149': '03',
    '151': '7B',
    '153': '8A',
    '155': '09',
    '157': '03',
    '159': '06',
    '161': '05',
    '163': '01',
    '165': '8A',
    '167': '03',
    '169': '8A',
    '171': '01',
    '173': '08',
    '175': '02',
    '177': '01',
    '179': '10',
    '181': '09',
    '183': '06',
    '185': '03',
    '187': '01',
    '189': '8A',
    '191': '10',
    '193': '7B',
    '195': '10',
    '197': '09',
    '199': '03',
    '201': '03',
    '203': '06',
    '205': '10',
    '207': '7B',
    '209': '01',
    '211': '10',
    '213': '05',
    '215': '04',
    '217': '05',
    '219': '8A',
    '221': '7B',
    '223': '05',
    '225': '06',
    '227': '08',
    '229': '08',
    '231': '05',
    '233': '10',
    '235': '7C',
    '237': '09',
    '239': '02',
    '241': '03',
    '243': '08',
    '245': '03',
    '247': '04',
    '249': '04',
    '251': '05',
    '253': '7B',
    '255': '02',
    '257': '05',
    '259': '01',
    '261': '04',
    '263': '8A',
    '265': '01',
    '267': '7C',
    '269': '8A',
    '271': '01',
    '273': '04',
    '275': '09',
    '283': '01',
    '277': '05',
    '279': '8A',
    '281': '7B',
    '285': '02',
    '287': '03',
    '289': '05',
    '291': '03',
    '293': '05',
    '295': '10',
    '297': '02',
    '299': '01',
    '301': '08',
    '303': '8A',
    '305': '8A',
    '313': '03',
    '315': '06',
    '317': '08',
    '319': '01',
    '321': '03',
    '323': '01',
    '307': '7C',
    '309': '05',
    '311': '01',
    '325': '01',
    '327': '7C',
    '329': '08',
    '331': '01',
    '333': '7B',
    '335': '08',
    '337': '09',
    '339': '03',
    '341': '10',
    '343': '06',
    '345': '8A',
    '347': '06',
    '349': '05',
    '351': '03',
    '353': '7B',
    '355': '04',
    '357': '10',
    '359': '10',
    '361': '03',
    '363': '7B',
    '365': '06',
    '367': '7B',
    '369': '10',
    '371': '08',
    '373': '03',
    '375': '10',
    '377': '08',
    '379': '05',
    '381': '10',
    '383': '7C',
    '385': '01',
    '387': '06',
    '389': '08',
    '391': '02',
    '393': '10',
    '395': '05',
    '397': '05',
    '399': '7C',
    '401': '06',
    '403': '06',
    '405': '06',
    '407': '03',
    '409': '04',
    '411': '7B',
    '413': '7C',
    '415': '8A',
    '417': '7B',
    '419': '06',
    '421': '10',
    '423': '06',
    '425': '7B',
    '427': '04',
    '429': '7B',
    '431': '08',
    '433': '7B',
    '435': '7C',
    '437': '10',
    '439': '05',
    '441': '7B',
    '443': '7C',
    '445': '8A',
    '447': '7B',
    '449': '06',
    '451': '7C',
    '453': '01',
    '455': '03',
    '457': '03',
    '459': '06',
    '461': '7C',
    '463': '01',
    '465': '01',
    '467': '05',
    '469': '02',
    '471': '03',
    '473': '03',
    '475': '08',
    '477': '03',
    '479': '04',
    '481': '03',
    '483': '10',
    '485': '09',
    '487': '09',
    '489': '04',
    '491': '01',
    '493': '01',
    '495': '08',
    '497': '09',
    '499': '06',
    '501': '8A',
    '503': '09',
    '505': '04',
    '507': '01'
};

export const symNumToClassificationName = {
    "2": "Permitted Location",
    "3": "Dry Hole",
    "4": "Oil Well",
    "5": "Gas Well",
    "6": "Oil/Gas Well",
    "7": "Plugged Oil Well",
    "8": "Plugged Gas Well",
    "9": "Canceled Location",
    "10": "Plugged Oil/Gas Well",
    "11": "Injection/Disposal Well",
    "19": "Shut-In Well (Oil)",
    "20": "Shut-In Well (Gas)"
};

export const keyMapping = {
    API: 'API Number',
    SYMNUM: 'Well Type',
    COMPLETION: 'Completion Date',
    FIELD_NAME: 'Field Name',
    LEASE_NAME: 'Lease Name',
    LEASE_ID: 'Lease Number',
    OPERATOR: 'Operator Name',
    OPERATOR_CONTACT: 'Operator Phone Number',
    PLUG_DATE: 'Plug Date',
    TOTAL_DEPTH: 'Total Depth',
    TOTAL_DEPT: 'Total Depth',
    LAST_PROD: 'Date of Last Production',
    LSE_GAS_PROD_VOL: 'Gas Produced',
    LSE_OIL_PROD_VOL: 'Oil Produced',
    LSE_COND_PROD_VOL: 'Condensate Produced',
    LSE_CSGD_PROD_VOL: 'Casinghead Gas Produced',
    LAST_FLARED: 'Date of Last Flare/Vent',
    FLARE_VOL: 'Volume Flared or Vented',
    COUNTY: 'County Code',
    LATERAL_LENGTH: 'Lateral Length',
    W_P: 'Well or Pipeline',
};

